/// <reference types="applepayjs" />
import { Injectable } from '@angular/core';

import { UrlConstants } from '../config/urlConstants';
import { BetslipQdApiService } from './betslipqd-api.service';
import { DataService } from './data.service';
import { DepositService } from './deposit.service';
import { UserDataService } from './userDataService';

@Injectable({
    providedIn: 'root',
})
export class ApplePayDirectService {
    validationURL: string;
    txnId: string;
    processorTxnID: string;
    session: ApplePaySession;
    userDataInfo: any;
    supportedNetworks: any = null;

    constructor(
        private apiService: BetslipQdApiService,
        private userDataService: UserDataService,
        public dataService: DataService,
        private depositService: DepositService,
    ) {}

    // TODO: not calling anywhere, check and remove
    getPaymentRequest(creditCardBanEnabled: string, countryCode: string, currencyCode: string, amount: string): any {
        const paymentRequest: any = {};
        paymentRequest.countryCode = countryCode;
        paymentRequest.currencyCode = currencyCode;
        paymentRequest.total = {};
        paymentRequest.total.label = '';
        paymentRequest.total.amount = amount;
        if (this.userDataService?.userData?.configParams?.supportedNetworks) {
            const supportedNetworksSplit = this.userDataService?.userData?.configParams.supportedNetworks.split(',');
            paymentRequest.supportedNetworks = supportedNetworksSplit;
        } else {
            paymentRequest.supportedNetworks = ['masterCard', 'visa', 'maestro', 'amex'];
        }
        paymentRequest.merchantCapabilities = creditCardBanEnabled === 'Y' ? ['supports3DS', 'supportsDebit'] : ['supports3DS'];

        return paymentRequest;
    }

    exactDomainUrl(parentHostName: string) {
        const domainUrl = parentHostName.match(/^(?:https?:\/\/)?([^\/]+)/);
        const parentDomain = domainUrl ? domainUrl[1] : '';
        return parentDomain;
    }

    processApplePayDeposit(depositSubmitReq: any, creditCardBanEnabled: string, countryCode: string, tokenUrl: any, cardToken?: string) {
        // Set country code and card ban

        let paymentRequest: ApplePayJS.ApplePayPaymentRequest | undefined = undefined;
        const userData = this.userDataService?.userData;
        const parentHostName = window.location !== window.parent.location ? document?.referrer?.substring(0, document?.referrer?.length - 1) : '';
        const exactDomain = this.exactDomainUrl(parentHostName);
        if ('ApplePaySession' in window && ApplePaySession.canMakePayments() === true) {
            try {
                if (this.userDataService?.userData?.configParams?.supportedNetworks) {
                    const supportedNetworksSplit = this.userDataService?.userData?.configParams.supportedNetworks.split(',');
                    this.supportedNetworks = supportedNetworksSplit;
                }

                if ('Y' === creditCardBanEnabled) {
                    paymentRequest = {
                        countryCode,
                        currencyCode: depositSubmitReq.amountInfo.nativeCurrency,
                        total: {
                            label: userData?.configParams?.applePayLabelValue ?? '',
                            type: 'final',
                            amount: depositSubmitReq.amountInfo.nativeAmountString + '',
                        },
                        supportedNetworks: this.supportedNetworks ? this.supportedNetworks : ['masterCard', 'visa', 'maestro', 'discover'],
                        merchantCapabilities: ['supports3DS', 'supportsDebit'],
                    };
                } else {
                    paymentRequest = {
                        countryCode,
                        currencyCode: depositSubmitReq.amountInfo.nativeCurrency,
                        total: {
                            label: userData?.configParams?.applePayLabelValue ?? '',
                            type: 'final',
                            amount: depositSubmitReq.amountInfo.nativeAmountString + '',
                        },

                        supportedNetworks:
                            this.supportedNetworks && this.supportedNetworks !== null
                                ? this.supportedNetworks
                                : ['masterCard', 'visa', 'maestro', 'amex', 'discover'],
                        merchantCapabilities: ['supports3DS'],
                    };
                }

                const session = new ApplePaySession(1, paymentRequest);
                session.onvalidatemerchant = (event) => {
                    try {
                        this.validationURL = event.validationURL;
                        this.apiService
                            .get(UrlConstants.GET_APPLEPAY_SESSION + '?validationUrl=' + this.validationURL + '&parentHostName=' + exactDomain)
                            .toPromise()
                            .then((response) => {
                                session.completeMerchantValidation(response);
                            })
                            .catch((err) => {
                                this.apiService.get('/commonservice/common/log?log=Exception occured in Applepay deposit Submit' + err).subscribe(
                                    () => {},
                                    () => {},
                                );
                            });
                    } catch (e) {
                        this.handleLogger(e, paymentRequest);
                    }
                };

                session.onpaymentauthorized = (event) => {
                    const payload = JSON.stringify(event.payment);
                    this.depositService
                        .registerCardDetails(tokenUrl, payload, cardToken)
                        .then((response: any) => {
                            depositSubmitReq.paymentAccountInfo.paymentAccountId = response?.body?.accounts[0].id;
                            depositSubmitReq.paymentAccountInfo.cardType = event.payment.token.paymentMethod.network;
                            depositSubmitReq.paymentAccountInfo.AccountFundingSource = event.payment.token.paymentMethod.type;
                            depositSubmitReq.paymentAccountInfo.originalCardEndDigits = event.payment.token.paymentMethod.displayName.split(' ')[1];
                            this.depositService.depositInfo.paymentAccountInfo.paymentAccountId = response?.body?.accounts[0].id;
                            this.depositService.depositInfo.paymentAccountInfo.cardType = event.payment.token.paymentMethod.network;
                            this.depositService.depositInfo.paymentAccountInfo.AccountFundingSource = event.payment.token.paymentMethod.type;
                            this.depositService.depositInfo.paymentAccountInfo.originalCardEndDigits =
                                event.payment.token.paymentMethod.displayName.split(' ')[1];
                            this.depositService.depositInfo.pageName = 'APPLEPAYDIRECT_input';
                            this.depositService.applePayDepositSubmit(depositSubmitReq).then((data: any) => {
                                if (data && data.status === 'SUCCESS') {
                                    session.completePayment(ApplePaySession.STATUS_SUCCESS);
                                } else {
                                    session.completePayment(ApplePaySession.STATUS_FAILURE);
                                    session.abort();
                                }
                            });
                        })
                        .catch((err: any) => {
                            session.abort();
                            this.handleLogger(err, paymentRequest);
                        });
                };
                session.begin();
            } catch (e) {
                this.handleLogger(e, paymentRequest);
            }
        }
    }
    handleLogger(e: any, paymentRequest: ApplePayJS.ApplePayPaymentRequest | undefined) {
        const payInfo = JSON.stringify(paymentRequest);
        const path = '/commonservice/common/log?log=Exception in validate Merchant for paymentRequest ' + payInfo + ' with exception ' + e;
        this.apiService.get(path).subscribe();
    }
}
